import Cookies from 'cookies-js';
import { sdkRequest, setWindowLocation } from 'js-utils/http';
import { formatUrl } from 'url-lib';
import { EVENT_COOKIE } from '../../constants';
var saveEventUrl = '/api/v3/destination/save/';
var unsaveEventUrl = '/api/v3/destination/unsave/';

var _saveOrUnsaveEvent = function _saveOrUnsaveEvent(url, eventId) {
  return sdkRequest(url, {
    method: 'POST',
    body: JSON.stringify({
      'event_ids': ["" + eventId]
    })
  });
};

export var saveEvent = function saveEvent(eventId) {
  return _saveOrUnsaveEvent(saveEventUrl, eventId);
};
export var unsaveEvent = function unsaveEvent(eventId) {
  return _saveOrUnsaveEvent(unsaveEventUrl, eventId);
};
export var loggedOutSaveRedirect = function loggedOutSaveRedirect(eventId, _ref) {
  var pathname = _ref.pathname,
      query = _ref.query;
  // save the cookie with organizer information
  Cookies.set(EVENT_COOKIE, eventId, {
    path: pathname,
    secure: true,
    expires: 300
  }); // then redirect to signin page

  setWindowLocation(formatUrl('/signin/', {
    referrer: formatUrl(pathname, query)
  }));
  return Promise.resolve();
};